/**
 * Bank Balances page for the Personal scope.
 *
 * Wraps BankBalancesSection with scope="personal" inside PersonalLayout.
 * Reacts to the entity selector in the sidebar (selectedEntity from
 * useEntityStore), filtering to the selected personal entity or showing
 * all personal entities when "all" / "group:personal" is selected.
 */

import { PersonalLayout } from '../components/PersonalLayout';
import { BankBalancesSection } from '../components/BankBalancesSection';
import { useEntityStore } from '../store';

export function PersonalBankBalancesPage({ embedded, onAccountClick } = {}) {
  var selectedEntity = useEntityStore(function (s) { return s.selectedEntity; });

  var content = (
      <div className="space-y-6" data-testid="bank-balances-page">
        <h1 className="text-3xl font-bold tracking-tight">Bank Balances</h1>
        <BankBalancesSection scope="personal" entityId={selectedEntity} onAccountClick={onAccountClick} />
      </div>
  );

  if (embedded) return content;

  return (
    <PersonalLayout>
      {content}
    </PersonalLayout>
  );
}

export function PersonalBankBalancesPageContent(props) {
  return <PersonalBankBalancesPage embedded {...props} />;
}
